import { useCallback, useEffect, useState } from 'react';
import { Feature } from '../types';
import { useAnalytics } from '@lib/analytics/analyticsContext';
import { FeatureFlagKey } from '../enums';
import { usePostHog } from '../providers/PostHogProvider';

export const useFeature = <K extends FeatureFlagKey>(featureFlagKey: K) => {
    // const { analytics } = useAnalytics();
    // const { callFeature } = usePostHog();
    // const [feature, setFeature] = useState<Feature<K>>();
    // const [error, setError] = useState<boolean>(false);
    // const [loading, setLoading] = useState<boolean>(true);

    // const _initializeStates = useCallback(() => {
    //     if (!loading) setLoading(true);
    //     if (error) setError(false);
    //     if (feature) setFeature(undefined);
    // }, [error, feature, loading]);

    // const _callFeature = useCallback(
    //     async (featureFlagKey: FeatureFlagKey) => {
    //         _initializeStates();

    //         try {
    //             const calledFeature = (await callFeature(
    //                 featureFlagKey
    //             )) as Feature<K>;
    //             setFeature(calledFeature);
    //         } catch (err) {
    //             console.error('[POSTHOG]: ', err);
    //             setError(true);
    //         } finally {
    //             setLoading(false);
    //         }
    //     },
    //     [_initializeStates, callFeature]
    // );

    // useEffect(() => {
    //     analytics.ready(() => {
    //         _callFeature(featureFlagKey);
    //     });
    // }, [analytics, featureFlagKey, _callFeature]);

    //return { feature, error, loading };
    return {
        feature: undefined,
        error: undefined,
        loading: false,
    } as unknown as {
        feature: Feature<K>;
        error: undefined;
        loading: boolean;
    };
};
